import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-post-list-img',
  templateUrl: './section-post-list-img.component.html',
  styleUrls: ['./section-post-list-img.component.css']
})
export class SectionPostListImgComponent implements OnInit {

  @Input() sectionInfo;
  @Input() rowsDisplayed;
  allVisible = false;
  
  constructor() { 
    !this.rowsDisplayed? this.rowsDisplayed = 2 : null;
  }

  ngOnInit(): void {
    !this.sectionInfo.cardId? this.sectionInfo.cardId = 'A' : null;
  }

  getVisibleRows(array){
    let res = [];
    for(const [index, item] of array.entries()){

      if(this.allVisible){
        res.push(item);
      }else{
        if (index<this.rowsDisplayed) {
          res.push(item);
        }
      }
    }
    return res;
  }

  openLink(link){
    window.open(link,'_blank');
  }

}
